import { B_RealEstateFormCreateBody } from "@/src-refactor/modules/store/qrtk/services/realestate/values/create-realestate.value";
import HTransformObject from "@rf-helper/transform-object.helper";
import CreatePropertyAdapter from "./create-property-adapter";
import { IPropertyForm } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
const UpdatePropertyAdapter: ICreatePropertyAdapter = (state: IPropertyForm) => {
  const body = CreatePropertyAdapter(state);

  // En update incluimos los documentos a eliminar cuando el formulario está en edición
  const payloadDirty: any = {
    ...body,
    remove_documents: state.remove_documents
  };
  return HTransformObject(payloadDirty, {
    removeUndefined: true,
    removeEmptyArray: true,
    removeNull: true,
    removeEmptyStrings: true,
    removeEmptyObjects: true
  });
};

type ICreatePropertyAdapter = (state: IPropertyForm) => B_RealEstateFormCreateBody;

export default UpdatePropertyAdapter;
